export const getProfile = /* GraphQL */ `
  query getProfile {
    getProfile {
      birthday
      email
      id
      gender
      name
      picture
    }
  }
`;

export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      email
      name
      picture
      followees(limit: 1000) {
        items {
          id
        }
      }
      followers(limit: 1000) {
        items {
          id
        }
      }
      polls {
        description
        id
        title
        secondLikieeId
        secondImage
        owner
        isActive
        firstLikieeId
        firstImage
        expires
        createdAt
        votes {
          id
          owner
          vote
          pollId
        }
      }
    }
  }
`;

export const getUserFollowers = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      followers {
        items {
          name
          id
          email
          picture
          followers {
            items {
              id
            }
          }
        }
      }
      followees {
        items {
          name
          id
          email
          picture
          followers {
            items {
              id
            }
          }
        }
      }
    }
  }
`;

export const searchUsers = /* GraphQL */ `
  query searchUsers($filter: SearchableUserFilterInput) {
    searchUsers(filter: $filter) {
      items {
        id
        gender
        picture
        name
        email
      }
    }
  }
`;

export const getUserProjects = /* GraphQL */ `
  query getUserProjects($userId: ID!) {
    getUser(id: $userId) {
      projects {
        items {
          icon
          id
          name
          visibility
          visibilityGroup
        }
      }
    }
  }
`;

export const getUserProjectLikiees = /* GraphQL */ `
  query getUserProjectLikiees($projectId: String!) {
    getUserProjectLikiees(projectId: $projectId) {
      items {
        id
        projects {
          items {
            id
          }
        }
        thumbnailURLs
        images
        status
        url
        affiliateURL
        imageURL
        price
        originalPrice
        priceTrend
        priceRange {
          min
          max
          currency
          count
        }
        currency
        name
        createdAt
      }
      nextToken
    }
  }
`;

export const getUsersWithIds = /* GraphQL */ `
  query getUsers($ids: [String!]) {
    getUsers(ids: $ids) {
      email
      name
      picture
      id
    }
  }
`;
